import { css, styled } from '@mui/material'

export const MainContainer = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isDrawer',
})<{ isDrawer?: boolean }>`
  display: flex;
  flex-direction: column;
  ${({ theme, isDrawer }) =>
    !isDrawer &&
    css`
      padding-bottom: ${theme.spacing(1.5)};
    `}
`

export const FooterContainer = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  align-self: stretch;
  padding: ${({ theme }) => theme.spacing(2, 2, 0.5, 2)};
`
